import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { MapboxMap } from 'components/MapboxMap'
import { useElementSize, useWindowSize } from 'usehooks-ts'
import { Histogramm } from 'components/Histogramm'
import smoothscroll from 'smoothscroll-polyfill'
import { createContext } from 'react'
import { strings_de } from './strings_de'
import { strings_fr } from './strings_fr'
smoothscroll.polyfill()

export const LanguageContext = createContext(strings_de)

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [selectedKmPop, setSelectedKmPop] = useState<number | undefined>(
    undefined
  )
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)
  const { width } = useWindowSize()
  const [ref, containerSize] = useElementSize()

  let part = properties ? properties.part : '1'

  useEffect(() => {
    setWindowHeight(window.innerHeight)
  }, [width, setWindowHeight])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <LanguageContext.Provider
        value={tenant && tenant.lang === 'fr' ? strings_fr : strings_de}
      >
        {part === '1' && (
          <div ref={ref}>
            <ZDiv>
              {containerSize.width > 0 && (
                <MapboxMap
                  tenant={tenant ? tenant.key : strings_de.fallbackTenant}
                  windowHeight={windowHeight}
                  containerWidth={containerSize.width}
                  colorMode={colorMode}
                  setSelectedKmPop={setSelectedKmPop}
                />
              )}
            </ZDiv>
          </div>
        )}

        {part === '2' && (
          <TextWidth>
            <Histogramm selectedKmPop={selectedKmPop} />
          </TextWidth>
        )}
      </LanguageContext.Provider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: var(--site-background);
`
export default MainComponent


const ZDiv=styled.div`
z-index: 1000;
`